<template>
  <el-form-item
    :label="currentField.label"
    :label-width="currentField.labelWidth + 'px'"
  >
    <el-date-picker
      v-model="date"
      v-bind="attributesBinding"
      type="datetime"
      placeholder="Select date and time"
      :id="currentField.model"
    ></el-date-picker>
  </el-form-item>
</template>

<script>
export default {
  name: "DatetimePicker",
  props: ["currentField"],
  data() {
    return {
      date: "",
    };
  },
  computed: {
    attributesBinding() {
      var attr = {};
      attr["id"] = this.currentField.model;
      attr.disabled = this.currentField.disabled;
      return attr;
    },
  },
};
</script>
